import { ElementType } from 'react'
import { connect } from 'redux-zero/react'
import { withRouter } from 'react-router-dom'

export default (component: ElementType, map: any = null) => {
  map = map ? map : state => state
  return withRouter(connect(map, {})(component))
}
